import "./index.css";

function Exp() {
  return (
    <section className="section3">
      <div className="headr">
        <h4>Explore My</h4>
        <h1>Experience</h1>
      </div>

      <div className="box">
        <div className="box--1">
          <h1>Frontend Development</h1>
          <div className="prd--">
            <div className="sip">
              <div>
                <i className="ri-html5-fill"></i>
              </div>
              <div>
                <h4>HTML</h4>
                <h5>Experienced</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-css3-fill"></i>
              </div>
              <div>
                <h4>CSS</h4>
                <h5>Experienced</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-tailwind-css-fill"></i>
              </div>
              <div>
                <h4>Tailwind CSS</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-javascript-fill"></i>
              </div>
              <div>
                <h4>JavaScript</h4>
                <h5>Advance</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-reactjs-line"></i>
              </div>
              <div>
                <h4>React</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-checkbox-circle-fill"></i>
              </div>
              <div>
                <h4>Redux</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="box--2">
          <h1>Backend Development</h1>
          <div className="prd--">
            <div className="sip">
              <div>
                <i className="ri-nodejs-fill"></i>
              </div>
              <div>
                <h4>Node JS</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-nextjs-line"></i>
              </div>
              <div>
                <h4>Next JS</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-checkbox-circle-fill"></i>
              </div>
              <div>
                <h4>Express JS</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
            <div className="sip">
              <div>
                <i className="ri-checkbox-circle-fill"></i>
              </div>
              <div>
                <h4>Mongo DB</h4>
                <h5>Intermediate</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Exp;
